import { Icon } from "../icons/icon";

export const CaretDown = () => {
  return (
    <Icon
      svg={"caret-down"}
      width={20}
      height={20}
      className={`w-[20px] group-hover:scale-90 group-hover:text-pry-green-200 transition-all`}
    />
  );
};
